export default class DtoCreateUser {
    constructor(user) {
        this.login = user.login
        this.name = user.name
        this.email = user.email
    }
}